import {useCartStatus} from "../../redux/stateHooks";
import {GPAWebDataTypesResourceType} from "../../api/openApi/cartService";
import {CartStateItemResource} from "../../redux/slices/carts";

/**
 * Returns the resource for the current cart item
 * Only a single resource is returned because the cart item can only have a single resource of a given type
 * @returns {{resource: CartStateItemResource | undefined}}
 * @param type
 */
export const useCartItemResource = (type: GPAWebDataTypesResourceType): { resource: CartStateItemResource | undefined; } => {
    const {resources} = useCartStatus();
    return {
        resource: getCartService(resources, type),
    }
}

/**
 * Returns the resource for the current cart item given a resource type
 * @param resources
 * @param type
 * @returns {CartStateItemResource | undefined}
 * @private
 * @param resources
 * @param type
 */
function getCartService(resources: CartStateItemResource[] | undefined, type: GPAWebDataTypesResourceType): CartStateItemResource | undefined {
    return resources?.find((resource) => resource.type === type);
}